var exec, pass;

helpers.stableMergeSort = function(arr, comp) {
  return exec(arr.slice(), comp);
};

exec = function(arr, comp) {
  var buffer, chk, len, tmp;
  if (typeof comp !== 'function') {
    comp = function(a, b) {
      return String(a).localeCompare(b);
    };
  }
  len = arr.length;
  if (len <= 1) {
    return arr;
  }
  buffer = new Array(len);
  chk = 1;
  while (chk < len) {
    pass(arr, comp, chk, buffer);
    tmp = arr;
    arr = buffer;
    buffer = tmp;
    chk *= 2;
  }
  return arr;
};

pass = function(arr, comp, chk, result) {
  var dbl, e, i, l, len, li, r, ri;
  len = arr.length;
  i = 0;
  dbl = chk * 2;
  l = void 0;
  r = void 0;
  e = void 0;
  li = void 0;
  ri = void 0;
  l = 0;
  while (l < len) {
    r = l + chk;
    e = r + chk;
    if (r > len) {
      r = len;
    }
    if (e > len) {
      e = len;
    }
    li = l;
    ri = r;
    while (true) {
      if (li < r && ri < e) {
        if (comp(arr[li], arr[ri]) <= 0) {
          result[i++] = arr[li++];
        } else {
          result[i++] = arr[ri++];
        }
      } else if (li < r) {
        result[i++] = arr[li++];
      } else if (ri < e) {
        result[i++] = arr[ri++];
      } else {
        break;
      }
    }
    l += dbl;
  }
};
